// Placeholder das telas ainda não implementadas pelos agentes de frontend.
// Cada arquivo de tela em aluno/** e painel/** começa renderizando isto; substitua pelo conteúdo real.
import { Painel } from "./Painel";

export function EmConstrucao({ titulo, referencia }: { titulo: string; referencia?: string }) {
  return (
    <div className="px-margem py-6 lg:px-0">
      <h1 className="text-h1 text-tinta">{titulo}</h1>
      <Painel className="mt-5">
        <p className="text-apoio text-texto-2">
          Tela em construção.
          {referencia && <span className="block text-rotulo text-texto-3">Referência: {referencia}</span>}
        </p>
      </Painel>
    </div>
  );
}
